<div class="scheduler__layout-control-container">
    <div class="scheduler__layout-control-container-calendar">
        <div [class]="'scheduler__container-' + calendarView">
            <transflo-calendar-header [calendarViewType]="viewDateCalendar" [calendarView]="view">
            </transflo-calendar-header>

            <div class="scheduler__calendar">
                <ng-container *ngIf="calendarView === 'month';else weekview">
                    <transflo-calendar-month (dayClicked)="dayClicked($event)" (decrementDate)='decrement($event)'
                        (incrementDate)='increment($event)' [viewDate]="viewDateCalendar" [events]="events"
                        [selectedDate]="selectedDate">
                    </transflo-calendar-month>
                </ng-container>
                <ng-template #weekview>
                    <transflo-calendar-week (dayClicked)="dayClicked($event)" (decrementDate)='decrement($event)'
                        (incrementDate)='increment($event)' [viewDate]="viewDateCalendar" [events]="events"
                        [selectedDate]="selectedDate">
                    </transflo-calendar-week>
                </ng-template>
            </div>

        </div>

        <div class="scheduler__toggle-button" (click)="toggleCalendarView()">
            <div class="scheduler__toggle-button-element"></div>
        </div>
    </div>
    <div *ngIf="flagIsActive" class="scheduler__flagged-agenda-header">Flagged Events</div>
    <div *ngIf="showloader" class="scheduler__notification {{notificationClass}}">
        {{notificationLabel}}</div>
</div>
